// extracted by mini-css-extract-plugin
export default {"recos":"W2-z","productCardOverride":"X2-z","rowHasBadge":"Y2-z"};